<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>{{ data.message }}</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">{{ data.cancelLabel || 'Cancel' }}</button>
    <button mat-flat-button color="warn" [mat-dialog-close]="true">{{ data.confirmLabel || 'Confirm' }}</button>
</mat-dialog-actions>
